import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TowageEditComponent } from './towage-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommHistoryModule } from 'src/app/shared/components/comm-history/comm-history.module';
import { AutoResizeInputDirective } from 'src/app/shared/helpers/auto-resize-input.directive';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { TowageEditRoutingModule } from './towage-edit-routing.module';



@NgModule({
  declarations: [
    TowageEditComponent
  ],
  imports: [
    CommonModule,
       MaterialModule,
        ReactiveFormsModule,
        AutoResizeInputDirective,
        CommHistoryModule,
TowageEditRoutingModule  ],
  exports: [
    TowageEditComponent
  ]
})
export class TowageEditModule { }
